import { useProviderDetailStore } from "../../store/provider-details/providerDetailStore";

import AdditionalContactEditView from "./AddionalContactEditView";

export default function AdditionalPhonesEditView(props) {
  const { additionalPhoneTypes, modifiedData } = useProviderDetailStore();

  return (
    <AdditionalContactEditView
      {...props}
      typesMap={additionalPhoneTypes}
      order={modifiedData.contactInfoOrder ?? []}
      orderKey="contactInfoOrder"
      dataMap={modifiedData.contactInfos}
      valueKey="display"
      addButtonLabel="Add Phone"
      emptyText="No additional phones"
      fieldSuffixLabel="Phone Number"
    />
  );
}
